import { GridHelper } from "three";
import { AmbientLight } from "three";
import { DirectionalLight } from "three";
import { Scene } from "three";


export class Studio extends Scene {
    constructor(lightsStrength = 1, withGrid = true) {
        super();

        var directionalLight = new DirectionalLight(0xffffff, 0.2);
        var directionalLight2 = new DirectionalLight(0xffffff, lightsStrength * .5);
        var ambientLight = new AmbientLight(0xffffff, 1);

        directionalLight.position.x = 2.0;
        directionalLight.position.z = 2.0;
        directionalLight.position.y = 0;
        this.add(directionalLight);
        //this.add(directionalLight2);
        this.add(ambientLight);
        if (withGrid) {
            const helper = new GridHelper();
            this.add(helper);
        }
    }
}